import { httpUrl } from "./httpUrl";

let baseUrl = `${httpUrl.host}/gy-parking`;
let baseUrl2 = `${httpUrl.host}/gy-apartment`;
let baseUrl3 = `${httpUrl.host}/gy-log`;
let baseUrl4 = `${httpUrl.host}/gy-video`
// let baseUrl = `${httpUrl.host}`
// let baseUrl2 = `${httpUrl.host}`
// let baseUrl3 = `${httpUrl.host}`

let api = {
  // 概览
  getParkingDeviceOverview: `${baseUrl}/parkingOverview/getParkingDeviceOverview`,

  getParkingDayOverview: `${baseUrl}/parkingOverview/getParkingDayOverview`,

  geParkingOtherOverview: `${baseUrl}/parkingOverview/geParkingOtherOverview`,

  getParkingConsumptionRecordStatictics: `${baseUrl}/parkingOverview/getParkingConsumptionRecordStatictics`,

  getParkingCarAccessRecordStatictics: `${baseUrl}/parkingOverview/getParkingCarAccessRecordStatictics`,

  getParkingDayStaticticsOverview: `${baseUrl}/parkingOverview/getParkingDayStaticticsOverview`,

  getParkingTrafficStaticticsOverview: `${baseUrl}/parkingOverview/getParkingTrafficStaticticsOverview`,

  // 查询设备分页
  getParkingDevicePage: `${baseUrl}/parkingDevice/getPage`,

  // 添加设备
  addParkingDevice: `${baseUrl}/parkingDevice/add`,

  // 修改设备
  updateParkingDevice: `${baseUrl}/parkingDevice/update`,

  // 查询单个设备
  getParkingDeviceByCode: `${baseUrl}/parkingDevice/getByCode`,

  // 删除设备
  deleteParkingDeviceByCode: `${baseUrl}/parkingDevice/deleteByCodes`,

  // 导出设备
  exportParkingDevice: `${baseUrl}/parkingDevice/export`,

  //导出在场车辆
  exportParkingPresentCar: `${baseUrl}/parkingPresentCar/export`,

  // 导入设备
  importParkingDevice: `${baseUrl}/parkingDevice/import`,

  // 设备列表
  getParkingAccessManageList: `${baseUrl}/parkingAccessManage/getList`,

  // 出入口管理查询账单
  getParkingBillList: `${baseUrl}/parkingAccessManage/getParkingBillList`,

  // 出入口管理开闸
  parkingAccessManageOpenGate: `${baseUrl}/parkingAccessManage/openGate`,

  // 查询金额配置详情
  getParkingBasicConfigByCode: `${baseUrl}/parkingBasicConfig/getByCode`,

  // 查询包月缴费记录分页
  getMonthRecordPage: `${baseUrl}/monthRecord/getPage`,

  // 导出包月缴费记录
  exportMonthRecord: `${baseUrl}/monthRecord/export`,

  // 查询临停/提前缴费记录分页
  getTempraryRecordPage: `${baseUrl}/tempraryRecord/getPage`,

  // 导出临停/提前缴费记录
  exportTempraryRecord: `${baseUrl}/tempraryRecord/export`,

  // 查询车辆进出记录分页
  getCarAccessRecordPage: `${baseUrl}/carAccessRecord/getCarAccessRecordPage`,

  // 查询车辆账单分页
  getParkingBillPage: `${baseUrl}/parkingBill/getPage`,

  //查询车辆包月账单分页
  getParkingMonthBillPage: `${baseUrl}/parkingMonthBill/getPage`,

  // 导出车牌识别记录
  exportCarRecognize: `${baseUrl}/carRecognize/export`,

  // 车牌识别记录分页
  getCarRecognizePage: `${baseUrl}/carRecognize/getCarRecognizePage`,

  // 导出账单
  exportParkingBill: `${baseUrl}/parkingBill/export`,

  // 导出车辆进出记录
  exportCarAccessRecordPage: `${baseUrl}/carAccessRecord/export`,

  // 添加授权信息
  addAuthority: `${baseUrl}/parkingCarManage/addParkingCarManage`,

  // 更新授权信息
  updateAuthority: `${baseUrl}/parkingCarManage/updateParkingCarManage`,

  // 删除授权
  deleteAuthorityByCodes: `${baseUrl}/parkingCarManage/deleteParkingCarManageByCodes`,

  // 查询授权分页
  getAuthorityPage: `${baseUrl}/parkingCarManage/getParkingCarManagePage`,

  // 查询授权列表
  getAuthorityList: `${baseUrl}/authority/getList`,

  // 查询单个授权信息
  getAuthorityByCode: `${baseUrl}/parkingCarManage/getParkingCarManageByCode`,

  // 导入授权信息
  importAuthority: `${baseUrl}/parkingCarManage/import`,

  // 导出授权信息
  exportAuthority: `${baseUrl}/parkingCarManage/export`,

  // 获取包月车辆
  getParkingMonthCarManagerPage: `${baseUrl}/parkingMonthCarManager/getPage`,

  // 导出包月车辆
  exportParkingMonthCarManagerPage: `${baseUrl}/parkingMonthCarManager/export`,

  // 导入包月车辆
  importParkingMonthCarManagerPage: `${baseUrl}/parkingMonthCarManager/import`,

  // 查询设备状态日志分页
  getDeviceStatusPage: `${baseUrl}/deviceStatus/getPage`,

  // 导出设备状态日志
  exportDeviceStatus: `${baseUrl}/deviceStatus/export`,

  // 查询缴费记录分页
  getPayRecordPage: `${baseUrl}/payRecord/getPage`,

  // 导出缴费记录
  exportPayRecordPage: `${baseUrl}/payRecord/export`,

  // 查询支付宝账号列表
  getAliAccountList: `${baseUrl}/aliAccount/getList`,

  // 查询车场列表
  getRentList: `${baseUrl}/carPlace/getRentList`,

  // 查询设备列表
  getParkingDeviceList: `${baseUrl}/parkingDevice/getList`,

  // 查询所有人员列表
  getResponsiblePersonList: `${baseUrl2}/person/getAllPersonInfo`,

  // 查询责任人列表
  getResponsible: `${baseUrl2}/person/getResponsiblePersonList`,

  // 查询操作日志
  getLogPage: `${baseUrl3}/log/getPage`,

  // 查询报警记录
  getParkingAlarmRecord: `${baseUrl}/parkingAlarmRecord/getPage`,

  // 导出报警记录
  exportParkingAlarmRecord: `${baseUrl}/parkingAlarmRecord/export`,

  // 查询金额配置列表
  getParkingPaymentConfigList: `${baseUrl}/parkingPaymentConfig/getParkingPaymentConfigList`,

  // 添加金额配置
  addParkingBasicConfig: `${baseUrl}/parkingPaymentConfig/add`,

  // 修改金额配置
  updateParkingBasicConfig: `${baseUrl}/parkingPaymentConfig/update`,

  // 删除金额配置
  deleteParkingBasicConfig: `${baseUrl}/parkingPaymentConfig/delete`,

  // 获取设备厂家
  getAllDeviceManufacture: `${baseUrl2}/common/getAllDeviceManufacture`,

  // 获取设备型号
  getAllDeviceType: `${baseUrl2}/common/getAllDeviceType`,

  // 获取显示屏分页
  getDisplayPage: `${baseUrl}/deviceShow/getPage`,

  // 获取显示屏详情
  getDisplayByCode: `${baseUrl}/deviceShow/getByCode`,

  // 添加或修改显示屏
  saveOrUpdateDisplay: `${baseUrl}/deviceShow/saveOrUpdate`,

  // 删除显示屏
  deleteDisplayByCode: `${baseUrl}/deviceShow/deleteByCode`,

  // 查询网关列表
  getGatewayList: `${baseUrl}/deviceShow/getGatewayList`,

  // 查询关联相机列表
  getDeviceShowParkingDeviceList: `${baseUrl}/deviceShow/getParkingDeviceList`,

  // 查询可选栏目
  getSelect: `${baseUrl}/deviceShow/getSelect`,

  // 添加岗亭账号
  addParkingAccount: `${baseUrl}/parkingAccount/addParkingAccount`,

  // 岗亭账号
  getParkingAccountByCode: `${baseUrl}/parkingAccount/getParkingAccountByCode`,

  // 删除岗亭账号
  deleteParkingAccountByCodes: `${baseUrl}/parkingAccount/deleteParkingAccountByCodes`,

  // 修改岗亭账号
  updateParkingAccount: `${baseUrl}/parkingAccount/updateParkingAccount`,

  // 获取岗亭账号
  getParkingAccountPageByCondition: `${baseUrl}/parkingAccount/getParkingAccountPageByCondition`,

  // 添加车场
  addParkingPlace: `${baseUrl}/parkingPlace/add`,

  // 车场分页
  getParkingPlacePage: `${baseUrl}/parkingPlace/getPage`,

  // 车场详情
  getParkingPlaceByCode: `${baseUrl}/parkingPlace/getCarByCode`,

  // 修改车场
  updateParkingPlace: `${baseUrl}/parkingPlace/update`,

  // 删除车场
  deleteParkingPlace: `${baseUrl}/parkingPlace/delete`,

  // 查询车场余位
  getParkingPlaceLeftNumber: `${baseUrl}/parkingPlace/getParkingPlaceLeftNumber`,

  // 查询车场余位
  getParkingPlaceOverview: `${baseUrl}/parkingOverview/getParkingPlaceOverview`,

  // 添加白/黑名单
  addCarWhiteBlack: `${baseUrl}/carWhiteBlack/add`,

  // 白/黑名单分页
  getCarWhiteBlackPage: `${baseUrl}/carWhiteBlack/getPage`,

  // 白/黑名单详情
  getCarCarWhiteBlackByCode: `${baseUrl}/carWhiteBlack/getCarByCode`,

  // 修改白/黑名单
  updateCarWhiteBlack: `${baseUrl}/carWhiteBlack/update`,

  // 删除白/黑名单
  deleteCarWhiteBlack: `${baseUrl}/carWhiteBlack/delete`,

  // 添加在场车辆
  addParkingPresentCar: `${baseUrl}/parkingPresentCar/add`,

  // 在场车辆分页
  getParkingPresentCarPage: `${baseUrl}/parkingPresentCar/getPage`,

  // 在场车辆详情
  getParkingPresentCarByCode: `${baseUrl}/parkingPresentCar/getPresentCarByCode`,

  // 修改在场车辆
  updateParkingPresentCar: `${baseUrl}/parkingPresentCar/update`,

  // 删除在场车辆
  deleteParkingPresentCar: `${baseUrl}/parkingPresentCar/delete`,

  // 添加微信收款账户
  addWxMoneyAccount: `${baseUrl}/parkingMoneyAccount/addWx`,

  // 微信收款账户分页
  getWxMoneyAccountPage: `${baseUrl}/parkingMoneyAccount/getWxPage`,

  // 微信收款账户详情
  getWxMoneyAccountByCode: `${baseUrl}/parkingMoneyAccount/getWxAccountByCode`,

  // 修改微信收款账户
  updateWxMoneyAccount: `${baseUrl}/parkingMoneyAccount/updateWx`,

  // 删除微信收款账户
  deleteWxMoneyAccount: `${baseUrl}/parkingMoneyAccount/deleteWx`,

  // 添加支付宝收款账户
  addAliMoneyAccount: `${baseUrl}/parkingMoneyAccount/addAliPay`,

  // 支付宝收款账户分页
  getAliMoneyAccountPage: `${baseUrl}/parkingMoneyAccount/getAliPayPage`,

  // 支付宝收款账户详情
  getAliMoneyAccountByCode: `${baseUrl}/parkingMoneyAccount/getAliPayAccountByCode`,

  // 修改支付宝收款账户
  updateAliMoneyAccount: `${baseUrl}/parkingMoneyAccount/updateAliPay`,

  // 删除支付宝收款账户
  deleteAliMoneyAccount: `${baseUrl}/parkingMoneyAccount/deleteAliPay`,

  // 其他配置   --  查询人员列表
  getResponsiblePerson: `${baseUrl}/otherConfig/person/getResponsiblePerson`,

  // 其他配置   --  添加授权
  addOtherConfigAuthorizer: `${baseUrl}/otherConfig/addAuthorizer`,

  // 其他配置   --  获取授权分页
  getOtherConfigPageAuthorizer: `${baseUrl}/otherConfig/getPageAuthorizer`,

  // 其他配置   --  查询授权
  getOtherConfigAuthorizer: `${baseUrl}/otherConfig/getAuthorizer`,

  // 其他配置   --  修改授权
  updateOtherConfigAuthorizer: `${baseUrl}/otherConfig/updateAuthorizer`,

  // 其他配置   --  删除授权
  deleteOtherConfigAuthorizer: `${baseUrl}/otherConfig/deleteAuthorizer`,

  // 购券账单
  getParkingCouponBillPage: `${baseUrl}/parkingCouponBill/getPage`,

  // 导出购券账单
  exportParkingCouponBillPage: `${baseUrl}/parkingCouponBill/export`,

  // 退券账单
  getParkingCouponBillReturnPage: `${baseUrl}/parkingCouponBillReturn/getPage`,

  // 导出退券账单
  exportParkingCouponBillReturnPage: `${baseUrl}/parkingCouponBillReturn/export`,

  // 优惠券缴费记录
  getConsumptionRecordForParkingCouponPage: `${baseUrl}/consumptionRecordForParkingCoupon/getPage`,

  // 导出优惠券缴费记录
  exportConsumptionRecordForParkingCoupon: `${baseUrl}/consumptionRecordForParkingCoupon/export`,

  // 优惠券添加
  parkingCouponIssueAdd: `${baseUrl}/parkingCouponIssue/add`,

  // 优惠券修改
  parkingCouponIssueUpdate: `${baseUrl}/parkingCouponIssue/update`,

  // 优惠券删除
  parkingCouponIssueDeleteByCodes: `${baseUrl}/parkingCouponIssue/deleteByCodes`,

  // 优惠券详情
  parkingCouponIssueGetByCode: `${baseUrl}/parkingCouponIssue/getByCode`,

  // 优惠券分页
  parkingCouponIssueGetPage: `${baseUrl}/parkingCouponIssue/getPage`,

  // 优惠券列表
  parkingCouponIssueGetList: `${baseUrl}/parkingCouponIssue/getList`,

  // 优惠券出售
  parkingCouponSaleAdd: `${baseUrl}/parkingCouponSale/add`,

  // 优惠券出售分页
  parkingCouponSaleGetPage: `${baseUrl}/parkingCouponSale/getPage`,

  // 优惠券出售列表
  parkingCouponSaleGetList: `${baseUrl}/parkingCouponSale/getList`,

  // 获取住户列表
  getEnterpriseList: `${baseUrl2}/enterpriseInfo/getEnterpriseList`,

  // 获取住户下人员列表
  getPersonListByEnterpriseCode: `${baseUrl}/parkingCouponSale/getPersonListByEnterpriseCode`,

  // 获取可退券住户列表
  getParkingCouponSaleEnterpriseList: `${baseUrl}/parkingCouponSale/getEnterpriseList`,

  // 优惠券退券
  parkingCouponReturnAdd: `${baseUrl}/parkingCouponReturn/add`,

  // 优惠券退券分页
  parkingCouponReturnGetPage: `${baseUrl}/parkingCouponReturn/getPage`,

  // 优惠券使用记录分页
  parkingCouponUseageRecordGetPage: `${baseUrl}/parkingCouponUseageRecord/getPage`,

  // 优惠券商户统计分页
  parkingCouponEnterpriseStatisticsGetPage: `${baseUrl}/parkingCouponEnterpriseStatistics/getPage`,

  //优惠券商户统计导出
  exportParkingCouponEnterpriseStatistics: `${baseUrl}/parkingCouponEnterpriseStatistics/export`,

  //优惠券使用记录导出
  exportParkingCouponUseageRecord: `${baseUrl}/parkingCouponUseageRecord/export`,

  //车位管理分页
  getParkingLotPage: `${baseUrl}/parkingLot/getPage`,

  //添加车位
  addParkingLot: `${baseUrl}/parkingLot/add`,

  //删除车位
  deleteParkingLotByCodes: `${baseUrl}/parkingLot/deleteByCodes`,

  //修改车位
  updateParkingLot: `${baseUrl}/parkingLot/update`,

  //查看车位
  getParkingLotByCode: `${baseUrl}/parkingLot/getByCode`,

  //获取车场配置
  getYardConfiguration: `${baseUrl}/otherConfig/getTempCarInConfig`,

  //修改车场配置
  modifyYardConfiguration: `${baseUrl}/otherConfig/updateCarInConfig`,

  //添加包月车绑定
  getFixedUnBindLot: `${baseUrl}/parkingLot/getFixedUnBindLot`,

  //添加包月车辆
  addByManager: `${baseUrl}/parkingMonthCarManager/addByManager`,

  //删除包月车辆
  deleteByManager: `${baseUrl}/parkingMonthCarManager/deleteByCodes`,

  //导入车位管理
  importParkingLot: `${baseUrl}/parkingLot/import`,

  //导出车位管理
  exportParkingLot: `${baseUrl}/parkingLot/export`,

  //导出包月账单
  exportParkingMonthBill: `${baseUrl}/parkingMonthBill/export`,

  //停车账单备注更新
  parkingBillUpdate: `${baseUrl}/parkingBill/update`,

  //包月车辆详情
  getMonthlyVehicleByCode: `${baseUrl}/parkingMonthCarManager/getByCode`,

  //包月车辆修改
  MonthlyVehicleUpdate: `${baseUrl}/parkingMonthCarManager/updateByManager`,

  //包月车辆退费
  MonthlyVehicleRefund: `${baseUrl}/parkingMonthCarManager/refundByManager`,

  //包月车辆续费
  MonthlyVehicleRenew: `${baseUrl}/parkingMonthCarManager/renewByManager`,

  //车位区域添加
  saveParkingLotArea: `${baseUrl}/parkingLotArea/saveParkingLotArea`,

  //车位区域列表
  getParkingLotAreaList: `${baseUrl}/parkingLotArea/getAllParkingLotArea`,

  //车位区域删除
  deleteParkingLotArea: `${baseUrl}/parkingLotArea/delParkingLotArea`,

  //车位区域详情
  getParkingLotAreaDetail: `${baseUrl}/parkingLotArea/getByCode`,

  //车位区域分页
  getParkingLotAreaPage: `${baseUrl}/parkingLotArea/getPageParkingLotArea`,

  //车位区域修改
  ModifyParkingLotArea: `${baseUrl}/parkingLotArea/updateParkingLotArea`,

  //车位租赁分页
  getParkingLotLeasePage: `${baseUrl}/parkingLotLease/getPage`,

  // 导入车位租赁
  importParkingRent: `${baseUrl}/parkingLotLease/import`,

  //导出车位租赁
  exportParkingRent: `${baseUrl}/parkingLotLease/export`,

  //作废车位租赁
  cancelParkingRent: `${baseUrl}/parkingLotLease/cancel`,

  //车位收费规则
  addLease: `${baseUrl}/parkingPaymentConfig/addLease`,

  //车位信息列表
  getParkingLotList: `${baseUrl}/parkingLot/getList`,

  //车位租赁添加
  addParkingLeaseByAdmin: `${baseUrl}/parkingLotLease/addParkingLeaseByAdmin`,

  //免费码使用记录
  getAuthCodeCarRecordPage: `${baseUrl}/authCodeCarRecord/getPage`,

  //获取所有的授权人列表
  getAuthorizerList: `${baseUrl}/otherConfig/getAuthorizerList`,

  // 导入白名单
  importCarWhiteBlack: `${baseUrl}/carWhiteBlack/import`,

  // 导出白名单
  exportCarWhiteBlack: `${baseUrl}/carWhiteBlack/export`,

  // 获取所有主相机设备
  getMainDevicesList: `${baseUrl}/parkingDevice/getMainDevices`,

  // 获取所有监控设备
  getVideoDeviceList: `${baseUrl4}/videoDevice/getDeviceListBean`,

  //优惠券使用记录导出
  exportAuthCodeCarRecord: `${baseUrl}/authCodeCarRecord/export`,

  //场中场配置——分页
  getInnerConfigPage: `${baseUrl}/inner/config/getPage`,

  //场中场配置——修改
  updateInnerConfig: `${baseUrl}/inner/config/update`,

  //场中场配置——车牌号分页
  getInnerCarNumberPage: `${baseUrl}/inner/carNumber/getPage`,

  //场中场配置——导入
  importInnerCarNumber: `${baseUrl}/inner/carNumber/import`,

  //场中场配置——导出
  exportInnerCarNumber: `${baseUrl}/inner/carNumber/export`,

  //场中场配置——添加车牌号
  addInnerCarNumber: `${baseUrl}/inner/carNumber/add`,

  //场中场配置——删除车牌号
  deleteInnerCarNumber: `${baseUrl}/inner/carNumber/deleteByCarNumber`,

  //班次管理——分页
  getParkingEmergencyRoutePage: `${baseUrl}/parkingEmergencyRoute/getPage`,

  //班次管理——添加
  addParkingEmergencyRoute: `${baseUrl}/parkingEmergencyRoute/add`,

  //班次管理——修改
  updateParkingEmergencyRoute: `${baseUrl}/parkingEmergencyRoute/update`,

  //班次管理——删除
  deleteParkingEmergencyRouteByCodes: `${baseUrl}/parkingEmergencyRoute/deleteByCodes`,

  //班次管理——详情
  getParkingEmergencyRouteByCode: `${baseUrl}/parkingEmergencyRoute/getByCode`,

  //班次管理——列表
  getParkingEmergencyRouteList: `${baseUrl}/parkingEmergencyRoute/getList`,

  //排班管理——分页
  getParkingEmergencyRoutePlanPage: `${baseUrl}/parkingEmergencyRoutePlan/getPage`,

  //排班管理——添加
  addParkingEmergencyRoutePlan: `${baseUrl}/parkingEmergencyRoutePlan/add`,

  //排班管理——修改
  updateParkingEmergencyRoutePlan: `${baseUrl}/parkingEmergencyRoutePlan/update`,

  //排班管理——删除
  deleteParkingEmergencyRoutePlanByCodes: `${baseUrl}/parkingEmergencyRoutePlan/deleteByCodes`,

  //排班管理——详情
  getParkingEmergencyRoutePlanByCode: `${baseUrl}/parkingEmergencyRoutePlan/getByCode`
};

export { api };



// WEBPACK FOOTER //
// ./src/view/api/ParkingService.js